import React from "react";

import { Modal, ModalProps, SubmitButtons } from "@examspark/common-ui";
import { PaddedBody } from "@examspark/common-ui/dist/components/modals/Modal";
import { IDSK } from "@examspark/types";

import ResourceViewer from "./ResourceViewer";

const ResourceViewerModal = (
  props: ModalProps & {
    resourceKey: IDSK;
  },
) => {
  return (
    <Modal
      title="Preview"
      size="large"
      buttons={
        <SubmitButtons
          onCancel={props.onRequestClose}
          onSubmit={() => {
            //
          }}
        />
      }
      {...props}
    >
      <PaddedBody>
        <ResourceViewer resourceKey={props.resourceKey} />
      </PaddedBody>
    </Modal>
  );
};
export default ResourceViewerModal;
